import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
export function BackToSettings() {
    const navigate = useNavigate();
    return (<Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/settings')}>
      All settings
    </Button>);
}
